// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__1NHNd","itemLink":"style_itemLink__33A1u","itemPic":"style_itemPic__2vXvO","itemIcon":"style_itemIcon__3nsa3"};